import { format, parse } from 'date-fns'

/**
 * Super quick and dirty markdown stripper.
 * This doesn't follow the full markdown spec & there are likely bugs
 *
 * TODO: use a library to do this, don't have time right now
 */
export function stripMarkdown(markdown: string): string {
  const withoutNewlines = markdown
    .replace(/\n/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
  const withoutHeaders = withoutNewlines.replace(/^#+\s+/, '')
  const withoutLinks = withoutHeaders.replace(/\[([^\]]+)\]\(([^)]+)\)/g, '$1')
  const withoutImages = withoutLinks.replace(/!\[([^\]]+)\]\(([^)]+)\)/g, '$1')
  const withoutCode = withoutImages.replace(/`+/g, '')
  const withoutItalics = withoutCode.replace(/\*+/g, '')
  const withoutBold = withoutItalics.replace(/\**/g, '')
  const withoutStrikethrough = withoutBold.replace(/~~/g, '')
  const withoutInlineCode = withoutStrikethrough.replace(/`/g, '')
  const withoutBlockQuotes = withoutInlineCode.replace(/^>\s+/gm, '')
  const withoutBullets = withoutBlockQuotes.replace(/^\s*\*\s+/gm, '')
  const withoutNumbers = withoutBullets.replace(/^\s*\d+\.\s+/gm, '')
  const withoutIndentation = withoutNumbers.replace(/^\s{2,}/gm, '')
  const withoutDashs = withoutIndentation.replace(/^\s*-\s+/gm, '')
  return withoutDashs
}

/*
  date should be formatted like 1/10/2022 for January 10, 2022
 */
export const parseAndFormatDateForPresRelease = (date: string) => {
  let formatted: string
  try {
    formatted = format(parse(date, 'M-d-yyyy', new Date()), 'PPP')
  } catch (e) {
    // We shouldn't fall in here if we've provided date correctly
    // but it will at least prevent a hard failure on the frontend
    // like is currently happening on some devices in production
    console.error(`Unable to parse date: ${date}`)
    return ''
  }
  return formatted
}
